import { gql, useMutation } from '@apollo/client';
import {
  Payments_DepositManualPaymentsMutation,
  Payments_DepositManualPaymentsMutationVariables,
} from '@/types';

const DEPOSIT_MANUAL_PAYMENTS_RESPONSE_FRAGMENT = gql`
  fragment DepositManualPaymentsResponseFields on DepositManualPaymentsResponse {
    alert_level
    alert_message
    manual_deposit_id
  }
`;

export const DEPOSIT_MANUAL_PAYMENTS_MUTATION = gql`
  mutation Payments_DepositManualPayments(
    $depositNumber: String!
    $employeeUUID: uuid!
    $paymentBatches: [ManualDepositPaymentBatchInput!]!
    $supplierUUID: uuid!
  ) {
    depositManualPayments(
      deposit_number: $depositNumber
      employee_id: $employeeUUID
      payment_batches: $paymentBatches
      supplier_id: $supplierUUID
    ) {
      ...DepositManualPaymentsResponseFields
    }
  }
  ${DEPOSIT_MANUAL_PAYMENTS_RESPONSE_FRAGMENT}
`;

export const useDepositManualPayments = () => {
  return useMutation<
    Payments_DepositManualPaymentsMutation,
    Payments_DepositManualPaymentsMutationVariables
  >(DEPOSIT_MANUAL_PAYMENTS_MUTATION);
};
